import { render } from "./DiceComponent.vue?vue&type=template&id=1e24287e&scoped=true"
import script from "./DiceComponent.vue?vue&type=script&lang=js"
export * from "./DiceComponent.vue?vue&type=script&lang=js"

import "./DiceComponent.vue?vue&type=style&index=0&id=1e24287e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\10-candles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e24287e"]])

export default __exports__